import {Grid} from "@mui/material"
import React, {useEffect} from "react"
import Content from "../../components/Content"
import { checkConditionsForHidden } from "../../misc/precondition-evaluation"

const ContainerPagination = ({container, value, triggerAction, getDataFromPointer}) => {
    const {action, children,
        maxPageItems = 5,
        containerSpacing = "16"
    } = container
    const pages = _.chunk(children.filter(child => !checkConditionsForHidden(child, getDataFromPointer)), maxPageItems)
    const activePage = value ?? 0
   
    useEffect(() => {
        action && triggerAction(action)
    }, [])
    
    return (
        <Grid justifyContent="space-between" container spacing={containerSpacing +"px"} columns={maxPageItems}>
            {pages[activePage]?.map((child) => (
                <Grid key={child.id}>
                    <Content child={child} />
                </Grid>
            ))}
        </Grid>
    )
}

export default ContainerPagination
